import * as React from "react";
import { useCallback } from "react";
import {
  Create,
  CreateProps,
  ImageField,
  ImageInput,
  SimpleForm,
  useCreate,
  useNotify,
  useRedirect,
} from "react-admin";
import { FieldValues } from "react-hook-form";
import { StyledToolbar } from "../../forms/StyledToolbar";
import {
  API_ENDPOINT_PATH,
  FRONT_IMAGES_PATH,
  MAX_FILE_SIZE,
} from "../../utils/const";
import { UploadDocumentsConstants as UDC } from "./../../utils/const";

export const UploadPhotosCreate: React.FC<CreateProps> = (props: any) => {
  const redirect = useRedirect();
  const notify = useNotify();

  const [create] = useCreate();

  const validateRequired = (value: any) => {
    return value ? undefined : UDC.notificationError;
  };

  const save = useCallback(
    async (values: FieldValues) => {
      try {
        const { photos } = values;
        const transformedValues = {
          createdAt: new Date(),
          link: photos.src,
          fileName: photos.title,
          rawData: photos.rawFile,
        };

        await create(
          API_ENDPOINT_PATH,
          { data: transformedValues },
          { returnPromise: true }
        );
        notify("Photo uploaded successfully", {
          type: "info",
          messageArgs: { smart_count: 1 },
        });
        redirect("list", FRONT_IMAGES_PATH);
      } catch (error: any) {
        if (error.body.errors) {
          Object.keys(error.body.errors).forEach((key) => {
            error.body.errors[key] = error.body.errors[key].join();
          });
          return error.body.errors;
        }
      }
    },
    [create, notify, redirect]
  );

  const validateFile = (value: any) => {
    if (value && value.rawFile) {
      const acceptedFormats = ["image/jpeg", "image/png", "application/pdf"];
      if (!acceptedFormats.includes(value.rawFile.type)) {
        return "Only .jpg, .png, and .pdf files are allowed";
      }
      if (value.rawFile.size > MAX_FILE_SIZE) {
        return UDC.validateSizeError;
      }
    }
    return undefined;
  };

  const handleBack = () => {
    redirect("list", FRONT_IMAGES_PATH);
  };

  return (
    <Create {...props} title={UDC.addDocumentTitle}>
      <SimpleForm
        onSubmit={save}
        toolbar={<StyledToolbar handleBack={handleBack} />}
      >
        <ImageInput
          source="photos"
          label={UDC.uploadPrompt}
          accept=".jpg,.png,.pdf"
          validate={[validateRequired, validateFile]}
          labelSingle={UDC.dragAndDropPrompt}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};
